import {GESCHAEFTSADRESSE} from "./ADDRESS_RELATION_TYPES.js";
import {FIRMA} from "./ADDRESS_RELATION_TYPES";

export const OWN_COMPANY_ADDRESS_TYPES = [GESCHAEFTSADRESSE];
export const DELETED_FILE_NAME = "deleted";
